export enum ExternalType {
    Appointment = 1,
    NursingManagement = 2,
    OperationManagement = 3,
    CpoeManagement = 4,
    CateringManagement = 5,
    VatIntegrationManagement = 6,
    HomeCare = 7,
    /** A shared dynamic (smart-form) module under the Tools rail module. */
    DynamicModule = 8,
}
